import { Guid } from "@app/core/constants/constants";
import { TagAlertEventType } from "./tag-alert-event-type.model";

export class TagAlert {
    eventType: TagAlertEventType;
    tagId: Guid;
    tagSessionHistoryId: Guid;
    tagCode: string;
    tagTypeId?: Guid;
    tagPropertyTemplateId: string;
    propertyName: string;
    readAt: Date;

    value: string;
    numberValue: number;
    booleanValue: boolean;
    dateTimeValue: Date;
    alert: AlertValidationResult;
    /** Authoritative rule severity: 1 danger, 2 warning, 3 information. */
    severity?: number | null;
    alertDescription: string;

    // Alert threshold values for translation
    measuredValue: string;
    thresholdValue: string;
    thresholdValueB: string;
    comparisonType: string;
    tolerance: number;
    accessRuleId?: string;
    accessRuleName?: string;
    permission?: number;
    zoneId?: string;
    zoneName?: string;
    isRecovery: boolean;
    alertStartTime?: Date;
    alertDuration?: number;
    alertStartValue?: string;
    locationNodeId?: string;
    locationNodeName?: string;
    locationNodeType?: number;
    locationNodePath?: string;
    locationEventId?: string;
    accessHistoryId?: string;
    locationUpdateStatus?: number;
    metadata?: Record<string, unknown>;



    constructor(data?: any) {
        if (data) {

            Object.assign(this, data);

            this.readAt = new Date(data.readAt);
            this.dateTimeValue = new Date(data.dateTimeValue);
            this.alertStartTime = data.alertStartTime ? new Date(data.alertStartTime) : undefined;

        }
    }
}

export enum AlertValidationResult {
    NoAlertSpecified,
    Alert,
    NoAlert
}
